import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Reporting } from './Reporting';
import { Error } from '../error/Error';
import { getOriginalUser } from '../../services/utilisateur';
import { CardTitle } from '../../utils/CardTitle';
import { StatistiqueIcon } from '../../utils/Icons';
var originalUser = getOriginalUser();
export var FicheStatistique = function () {
    var renderBilanReporting = function () {
        return _jsx(Reporting, {});
    };
    if (!originalUser.CanReadStatistique /* && !originalUser.CanReadRequete*/) {
        return _jsx(Error, { status: 401 });
    }
    /*let onglets = []
    if (originalUser.CanReadStatistique) {
      onglets.push({
        label: 'Reporting',
        component: () => renderBilanReporting(),
      })
    }
  
    if (originalUser.CanReadRequete) {
      onglets.push({ label: 'Requêtes', component: () => <Requete /> })
    }*/
    return (_jsxs(_Fragment, { children: [_jsx(CardTitle, { title: "Statistiques", startIcon: _jsx(StatistiqueIcon, {}), color: "neutre", withFileAriane: true }), renderBilanReporting()] }));
};
//# sourceMappingURL=FicheStatistique.js.map